const mediaItems = [
  {
    title: '海角视频 · 本周热播精选',
    desc: '精选本周海角视频区最受欢迎的作品合集，涵盖创意短片、知识科普、生活记录等多元类型。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20video%20content%20thumbnail%20with%20play%20button%20overlay%2C%20abstract%20creative%20studio%20scene%2C%20soft%20coral%20and%20cream%20gradient%20background%2C%20editorial%20illustration%20style%2C%20clean%20composition&width=600&height=340&seq=media-1&orientation=landscape',
    views: '32.6万',
    duration: '合集',
  },
  {
    title: '创作者面对面 · 深度访谈',
    desc: '海角社推出的创作者访谈节目，带你走近海角网千万原创背后的优秀作者与他们的创作故事。',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20interview%20scene%20illustration%20with%20two%20abstract%20figures%20conversing%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20editorial%20illustration%20style%2C%20gentle%20lighting%2C%20clean%20and%20professional&width=600&height=340&seq=media-2&orientation=landscape',
    views: '18.9万',
    duration: '系列',
  },
  {
    title: '社区精彩瞬间 · 月度回顾',
    desc: '回顾海角社区本月最精彩的互动瞬间，从热门帖子到趣味评论，记录社区的每一个高光时刻。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20community%20highlight%20collage%20illustration%20with%20floating%20moments%20and%20interactions%2C%20soft%20coral%20and%20cream%20background%2C%20editorial%20illustration%20style%2C%20vibrant%20yet%20gentle%20atmosphere&width=600&height=340&seq=media-3&orientation=landscape',
    views: '25.3万',
    duration: '回顾',
  },
  {
    title: '海角在线 · 新功能演示',
    desc: '海角网最新功能上手演示，从AI辅助创作到社区新玩法，带你快速了解海角在线的每一次升级。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20tech%20feature%20demo%20illustration%20with%20floating%20UI%20elements%2C%20warm%20coral%20and%20cream%20gradient%20background%2C%20editorial%20illustration%20style%2C%20modern%20and%20clean%20feel&width=600&height=340&seq=media-4&orientation=landscape',
    views: '15.7万',
    duration: '演示',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            海角视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            热门视频内容一览
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-xl md:text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-foreground-900/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}